












import Component from 'vue-class-component'
import Vue from 'vue'
import UnifyPageContent from '@/shared/components/unify/unify-page-content.vue'
import UnifyHero from '@/shared/components/unify/unify-hero.vue'
import { Prop } from 'vue-property-decorator'

@Component({
  components: { UnifyHero, UnifyPageContent },
})
export default class UnifyPage extends Vue {
  @Prop({
    default: () => false,
    type: Boolean,
  })
  public readonly h2!: boolean
}
